import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicLayout from './pages/PublicLayout';
import HomePage from './pages/HomePage';
import NewsDetail from './pages/NewsDetail';
import NewsArchive from './pages/NewsArchive'; // импортируем существующий файл
import CandidatePage from './pages/CandidatePage';
import AdminLogin from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import NewsAdmin from './pages/Admin/NewsAdmin';
import CandidatesAdmin from './pages/Admin/CandidatesAdmin';
import GalleryAdmin from './pages/Admin/GalleryAdmin';
import GalleryPage from './pages/GalleryPage';
import AdminRoute from './components/AdminRoute';
import SitePage from './pages/SitePage';
import PagesAdmin from './pages/Admin/PagesAdmin';
import GalleryArchiveList from './pages/GalleryArchiveList';
import GalleryArchiveFolder from './pages/GalleryArchiveFolder';
import DocumentsAdmin from './pages/Admin/DocumentsAdmin';
import './styles/App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Публичные маршруты */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path="news/:id" element={<NewsDetail />} />
          <Route path="candidate/:id" element={<CandidatePage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="gallery/archives" element={<GalleryArchiveList />} />
          <Route path="gallery/archive/:folderName" element={<GalleryArchiveFolder />} />
          <Route path="archived-news" element={<NewsArchive />} />
          <Route path="documents" element={<SitePage slug="documents" />} />
          <Route path="program" element={<SitePage slug="program" />} />
          <Route path="events" element={<SitePage slug="events" />} />
          <Route path="howtojoin" element={<SitePage slug="howtojoin" />} />
          <Route path="privacy" element={<SitePage slug="privacy" />} />
        </Route>

        {/* Админка */}
      <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><Dashboard /></AdminRoute>} />
        <Route path="/admin/news" element={<AdminRoute><NewsAdmin /></AdminRoute>} />
        <Route path="/admin/candidates" element={<AdminRoute><CandidatesAdmin /></AdminRoute>} />
        <Route path="/admin/gallery" element={<AdminRoute><GalleryAdmin /></AdminRoute>} />
        <Route path="/admin/pages" element={<AdminRoute><PagesAdmin /></AdminRoute>} />
        <Route path="/admin/documents" element={<AdminRoute><DocumentsAdmin /></AdminRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;